import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Popup } from "react-leaflet";
import { putData } from "../../../Core/Projects/action";
import { changeData } from "../../../Core/ChangeValues/action";
import styles from "../../../Assets/Styles/Components/Book/Map/MarkerPopup.module.css";

class MarkerPopup extends Component {
  returnLocation = () => () => {
    const exData = { shoot_location_slug: this.props.data.slug, address_latitude: this.props.data.lat, address_longitude: this.props.data.lng, address_detail: this.props.data.detail, search_for_studio: false, delivery_at_location: this.props.checked };
    const { slug, data } = this.props.project;
    this.props.putData(slug, { ...data, ...exData, step: this.props.history.location.pathname.slice(1).split("/")[1] });
    this.props.changeData();
  }

  render() {
    const { title, detail, avatar, has_cost, link_url } = this.props.data;
    return (
      <Popup>
        <div className={styles.poup}>
          {avatar?.medium && <img src={`https://www.kadro.co${avatar.medium}`} alt="" />}
          <h4>{title}</h4>
          <p>{detail}</p>
          {
            has_cost && link_url ?
              <a target="_blank" rel="noreferrer" href={`${link_url}`}>
                <div className={`shoot_location_select ${styles.costBtn}`}>
                  <i className="fa fa-share" aria-hidden="true" />
                  &nbsp;
                  رزرو این مکان
                </div>
              </a>
              :
              <div onClick={this.returnLocation()} className={`shoot_location_select ${styles.btn}`}>انتخاب</div>
          }
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    project: state.project
  };
};
export default connect(mapStateToProps, { putData, changeData })(withRouter(MarkerPopup));
